import { ApiService } from 'services';
import { handleException } from 'actions/exceptions';
import { resetIsWhsLinkingActive } from 'actions/withholding';
import WhsLinkOperationStatus from 'common/Accounts/WhsLinkOperationStatus';

export const LOAD_ACCOUNT = 'LOAD_ACCOUNT';
export const LOAD_ACCOUNT_DATA = 'LOAD_ACCOUNT_DATA';
export const LOAD_ACCOUNT_DATA_FAILURE = 'LOAD_ACCOUNT_DATA_FAILURE';
export const LINK_ACCOUNT_CUSTOMER = 'LINK_ACCOUNT_CUSTOMER';
export const UNLINK_ACCOUNT_CUSTOMER = 'UNLINK_ACCOUNT_CUSTOMER';
export const LINK_ACCOUNT_FORM = 'LINK_ACCOUNT_FORM';
export const UNLINK_ACCOUNT_FORM_REQUEST = 'UNLINK_ACCOUNT_FORM_REQUEST';
export const UNLINK_ACCOUNT_FORM_SUCCESS = 'UNLINK_ACCOUNT_FORM_SUCCESS';
export const UNLINK_ACCOUNT_FORM_FAILURE = 'UNLINK_ACCOUNT_FORM_FAILURE';
export const CLEAR_ACCOUNT_REQUEST = 'CLEAR_ACCOUNT_REQUEST';
export const OPEN_UNLINK_FORM_MODAL = 'OPEN_UNLINK_FORM_MODAL';
export const CLOSE_UNLINK_FORM_MODAL = 'CLOSE_UNLINK_FORM_MODAL';
export const OPEN_ACCOUNT_NUMBER_CHANGE_FORM_MODAL = 'OPEN_ACCOUNT_NUMBER_CHANGE_FORM_MODAL';
export const CLOSE_ACCOUNT_NUMBER_CHANGE_FORM_MODAL = 'CLOSE_ACCOUNT_NUMBER_CHANGE_FORM_MODAL';
export const CLOSE_ACCOUNT_NUMBER_CHANGE_FORM_ERROR = 'CLOSE_ACCOUNT_NUMBER_CHANGE_FORM_ERROR';
export const ACCOUNT_NUMBER_CHANGE_CLEAR_REQUEST = 'ACCOUNT_NUMBER_CHANGE_CLEAR_REQUEST';
export const OPEN_LINK_IMY_STRUCTURE_CONFIRM_MODAL = 'OPEN_LINK_IMY_STRUCTURE_CONFIRM_MODAL';
export const CLOSE_LINK_IMY_STRUCTURE_CONFIRM_MODAL = 'CLOSE_LINK_IMY_STRUCTURE_CONFIRM_MODAL';
export const LINK_ACCOUNT_TO_IMY_STRUCTURE_REQUEST = 'LINK_ACCOUNT_TO_IMY_STRUCTURE_REQUEST';
export const LINK_ACCOUNT_TO_IMY_STRUCTURE_SUCCESS = 'LINK_ACCOUNT_TO_IMY_STRUCTURE_SUCESS';
export const LINK_ACCOUNT_TO_IMY_STRUCTURE_FAILURE = 'LINK_ACCOUNT_TO_IMY_STRUCTURE_FAILURE';
export const WHS_LINK_OPERATION_STATUS_REQUEST = 'WHS_LINK_OPERATION_STATUS_REQUEST';
export const WHS_LINK_OPERATION_STATUS_SUCCESS = 'WHS_LINK_OPERATION_STATUS_SUCCESS';
export const WHS_LINK_OPERATION_STATUS_FAILED = 'WHS_LINK_OPERATION_STATUS_FAILED ';
export const WHS_LINK_OPERATION_STATUS_RETRIES_FAILED = 'WHS_LINK_OPERATION_STATUS_RETRIES_FAILED';
export const WHS_LINK_OPERATION_STATUS_LIST_REQUEST = 'WHS_LINK_OPERATION_STATUS_LIST_REQUEST';
export const WHS_LINK_OPERATION_STATUS_LIST_SUCCESS = 'WHS_LINK_OPERATION_STATUS_LIST_SUCCESS';
export const WHS_LINK_OPERATION_STATUS_LIST_FAILED = 'WHS_LINK_OPERATION_STATUS_LIST_FAILED';

function requestLoadAccount(account) {
  return {
    type: LOAD_ACCOUNT,
    storeAccount: account
  };
}

function requestLoadAccountData() {
  return {
    type: LOAD_ACCOUNT_DATA,
  };
}

function clearAccount() {
  return {
    type: CLEAR_ACCOUNT_REQUEST,
  };
}

function requestLinkAccountCustomer() {
  return {
    type: LINK_ACCOUNT_CUSTOMER,
  };
}

function requestUnlinkAccountCustomer() {
  return {
    type: UNLINK_ACCOUNT_CUSTOMER,
  };
}

function requestLinkAccountForm() {
  return {
    type: LINK_ACCOUNT_FORM,
  };
}

function requestUnlinkAccountForm() {
  return {
    type: UNLINK_ACCOUNT_FORM_REQUEST,
  };
}

function rejectUnlinkAccountForm(error) {
  return {
    type: UNLINK_ACCOUNT_FORM_FAILURE,
    unlinkFormError: error.message
  };
}

function receiveUnlinkAccountForm() {
  return {
    type: UNLINK_ACCOUNT_FORM_SUCCESS
  };
}

function rejectAccountDataLoad(accountDataLoadError) {
  return {
    type: LOAD_ACCOUNT_DATA_FAILURE,
    accountDataLoadError
  };
}

function openUnlinkFormModal() {
  return {
    type: OPEN_UNLINK_FORM_MODAL
  };
}

function closeUnlinkFormModal() {
  return {
    type: CLOSE_UNLINK_FORM_MODAL
  };
}

function closeAccountNumberChangeFormError() {
  return {
    type: CLOSE_ACCOUNT_NUMBER_CHANGE_FORM_ERROR,
    isAccountNumberChangeModalShown: true
  };
}

function openAccountNumberChangeModal() {
  return {
    type: OPEN_ACCOUNT_NUMBER_CHANGE_FORM_MODAL,
    isAccountNumberChangeModalShown: true
  };
}

function openLinkToImyStructureConfirmModal(targetWhsLinkAccount) {
  return {
    type: OPEN_LINK_IMY_STRUCTURE_CONFIRM_MODAL,
    targetWhsLinkAccount
  };
}

function closeLinkToImyStructureConfirmModal() {
  return {
    type: CLOSE_LINK_IMY_STRUCTURE_CONFIRM_MODAL
  };
}

function closeAccountNumberChangeModal(id) {
  if (id === true || id === false) {
    return {
      type: CLOSE_ACCOUNT_NUMBER_CHANGE_FORM_MODAL,
      isAccountNumberChangeModalShown: false
    };
  }
  return {
    type: CLOSE_ACCOUNT_NUMBER_CHANGE_FORM_MODAL,
    isAccountNumberChangeModalShown: false,
    returnedExistingAccountId: id
  };
}

function linkAccountToImyStructureRequest() {
  return {
    type: LINK_ACCOUNT_TO_IMY_STRUCTURE_REQUEST
  };
}

function receiveLinkAccountToImyStructure(accountWhsLinkStatus) {
  return {
    type: LINK_ACCOUNT_TO_IMY_STRUCTURE_SUCCESS,
    accountWhsLinkStatus,
    isLinkingToImyStructureModalShown: !!(accountWhsLinkStatus && accountWhsLinkStatus.status !== 100)
  };
}

function rejectLinkAccountToImyStructure() {
  return {
    type: LINK_ACCOUNT_TO_IMY_STRUCTURE_FAILURE
  };
}

function refreshAccountPage(accountWhsLinkStatus) {
  if (accountWhsLinkStatus && accountWhsLinkStatus.status === 100) {
    window.location.reload(false);
  }
}

function getLinkOperationStatusRequest() {
  return {
    type: WHS_LINK_OPERATION_STATUS_REQUEST,
    isGettingWhsLinkOperationStatus: true
  };
}

function getWhsLinkOperationStatusReceived(accountWhsLinkStatus, dispatch) {
  if (accountWhsLinkStatus && accountWhsLinkStatus.status === 100) {
    dispatch(resetIsWhsLinkingActive());
  }

  return {
    type: WHS_LINK_OPERATION_STATUS_SUCCESS,
    isGettingWhsLinkOperationStatus: false,
    accountWhsLinkStatus,
    isLinkingToImyStructureModalShown: !!(accountWhsLinkStatus && accountWhsLinkStatus.status !== 100)
  };
}

function getLinkOperationStatusRetriesFailed() {
  return {
    type: WHS_LINK_OPERATION_STATUS_RETRIES_FAILED
  };
}

function getLinkOperationStatusFailed() {
  return {
    type: WHS_LINK_OPERATION_STATUS_FAILED,
    isGettingWhsLinkOperationStatus: true
  };
}

function getLinkOperationStatusesRequest() {
  return {
    type: WHS_LINK_OPERATION_STATUS_LIST_REQUEST,
  };
}

function getWhsLinkOperationStatusesReceived(whsLinkStatuses) {
  return {
    type: WHS_LINK_OPERATION_STATUS_LIST_SUCCESS,
    whsLinkStatuses
  };
}

function getLinkOperationStatusesFailed() {
  return {
    type: WHS_LINK_OPERATION_STATUS_LIST_FAILED,
  };
}

export function GetLinkOperationStatus(accountId, reloadOnComplete) {
  return (dispatch) => {
    dispatch(getLinkOperationStatusRequest());

    const promise = () => ApiService
      .getLinkOperationStatus(accountId)
      .then((response) => {
        if (response.data.status === WhsLinkOperationStatus.Error) {
          dispatch(getLinkOperationStatusRetriesFailed());
          return;
        }
        dispatch(getWhsLinkOperationStatusReceived(response.data, dispatch));
        if (reloadOnComplete) {
          dispatch(refreshAccountPage(response.data));
        }
      })
      .catch((error) => {
        if (!error.response && error.retries && error.retries > 1) {
          ApiService.addQueuedPromise(promise, error);
        }
        if (error.response || (error.retries && error.retries > 1)) {
          dispatch(handleException(error, getLinkOperationStatusFailed, true));
          if (error.retries && error.retries > 1) {
            dispatch(getLinkOperationStatusRetriesFailed());
          }
        }
      });
    return promise();
  };
}

export function GetLinkOperationStatuses(accountIds) {
  return (dispatch) => {
    dispatch(getLinkOperationStatusesRequest());

    const promise = () => ApiService
      .getLinkOperationStatuses(accountIds)
      .then((response) => {
        dispatch(getWhsLinkOperationStatusesReceived(response.data));
      })
      .catch((error) => {
        if (!error.response && error.retries && error.retries > 1) {
          ApiService.addQueuedPromise(promise, error);
        }
        if (error.response || (error.retries && error.retries > 1)) {
          dispatch(handleException(error, getLinkOperationStatusesFailed, true));
        }
      });
    return promise();
  };
}

export function accountDataLoad(accountId) {
  return (dispatch) => {
    dispatch(requestLoadAccountData());

    const promise = () => ApiService
      .getAccountData(accountId)
      .then((response) => {
        dispatch(requestLoadAccount(response.data));
        if (response.data && !!response.data.isWhsLinkingActive) {
          dispatch(GetLinkOperationStatus(response.data.id));
        }
      })
      .catch((error) => {
        if (!error.response && error.retries && error.retries > 1) {
          ApiService.addQueuedPromise(promise, error);
        }
        dispatch(handleException(error, rejectAccountDataLoad));
      });

    return promise();
  };
}

export function clearAccountData() {
  return dispatch => dispatch(clearAccount());
}

export function accountCustomerLink(accountId, addedCustomerData) {
  return (dispatch) => {
    dispatch(requestLinkAccountCustomer());

    const accountCustomer = {
      CustomerId: addedCustomerData.customerId,
      Capacity: addedCustomerData.capacity,
      ValidFrom: addedCustomerData.validFrom,
      ValidUntil: addedCustomerData.validUntil,
      Account: {
        id: accountId
      }
    };

    const customerAccount = [accountCustomer];

    const promise = () => ApiService
      .linkCustomerAccount(addedCustomerData.customerId, customerAccount)
      .then((response) => {
        dispatch(accountDataLoad(accountId));
      })
      .catch((error) => {
        if (!error.response && error.retries && error.retries > 1) {
          ApiService.addQueuedPromise(promise, error);
        }
        if (error.response || (error.retries && error.retries > 1)) {
          dispatch(handleException(error, true, true));
        }
      });
    return promise();
  };
}

export function hideAccountNumberChangeFormError() {
  return (dispatch) => {
    dispatch(closeAccountNumberChangeFormError());
  };
}

export function showAccountNumberChangeModal() {
  return (dispatch) => {
    dispatch(openAccountNumberChangeModal());
  };
}

export function hideAccountNumberChangeModal(id) {
  return (dispatch) => {
    dispatch(closeAccountNumberChangeModal(id));
  };
}

export function accountCustomerUnlink(accountId, customerId) {
  const accountCustomer = [accountId];

  return (dispatch) => {
    dispatch(requestUnlinkAccountCustomer());

    const promise = () => ApiService
      .unLinkCustomerAccount(customerId, accountCustomer)
      .then((response) => {
        dispatch(accountDataLoad(accountId));
      })
      .catch((error) => {
        if (!error.response && error.retries && error.retries > 1) {
          ApiService.addQueuedPromise(promise, error);
        }

        if (error.response || (error.retries && error.retries > 1)) {
          dispatch(handleException(error, true, true));
        }
      });
    return promise();
  };
}

export function accountFormLink(accountId, formId) {
  return (dispatch) => {
    dispatch(requestLinkAccountForm());

    const promise = () => ApiService
      .linkAccountForm(accountId, formId)
      .then((response) => {
        dispatch(accountDataLoad(accountId));
      })
      .catch((error) => {
        if (!error.response && error.retries && error.retries > 1) {
          ApiService.addQueuedPromise(promise, error);
        }

        if (error.response || (error.retries && error.retries > 1)) {
          dispatch(handleException(error, true, true));
        }
      });
    return promise();
  };
}

export function accountFormUnlink(accountId, formId) {
  const formIds = [formId];

  return (dispatch) => {
    dispatch(requestUnlinkAccountForm());

    const promise = () => ApiService
      .unLinkAccountForm(accountId, formIds)
      .then((response) => {
        dispatch(receiveUnlinkAccountForm());
        dispatch(accountDataLoad(accountId));
      })
      .catch((error) => {
        if (!error.response && error.retries && error.retries > 1) {
          ApiService.addQueuedPromise(promise, error);
        }

        if (error.response || (error.retries && error.retries > 1)) {
          dispatch(handleException(error, rejectUnlinkAccountForm, false));
        }
      });
    return promise();
  };
}

export function showUnlinkFormModal() {
  return (dispatch) => {
    dispatch(openUnlinkFormModal());
  };
}

export function hideUnlinkFormModal() {
  return (dispatch) => {
    dispatch(closeUnlinkFormModal());
  };
}

export function processAccountNumberChange(data) {
  const formData = new FormData();
  formData.append('newAccountNumber', data.newNumber);

  return (dispatch) => {
    const promise = () => ApiService
      .updateAccountNumber(data.id, formData)
      .then((response) => {
        dispatch(hideAccountNumberChangeModal(response.data));
        if (response.data === true || response.data === false) {
          dispatch(accountDataLoad(data.id));
        }
      })
      .catch((error) => {
        if (!error.response && error.retries && error.retries > 1) {
          ApiService.addQueuedPromise(promise, error);
        }

        if (error.response || (error.retries && error.retries > 1)) {
          dispatch(handleException(error, null, true));
        }
      });
    return promise();
  };
}

export function showLinkToImyStructureConfirmModal(targetWhsLinkAccount) {
  return (dispatch) => {
    dispatch(openLinkToImyStructureConfirmModal(targetWhsLinkAccount));
  };
}

export function hideLinkToImyStructureConfirmModal() {
  return (dispatch) => {
    dispatch(closeLinkToImyStructureConfirmModal());
  };
}

export function linkAccountToImyStructure(accountId, accountIdToLinkTo) {
  return (dispatch) => {
    dispatch(linkAccountToImyStructureRequest());

    const promise = () => ApiService
      .linkAccountToImyStructure(accountId, accountIdToLinkTo)
      .then((response) => {
        dispatch(receiveLinkAccountToImyStructure(response.data));
      })
      .catch((error) => {
        if (!error.response && error.retries && error.retries > 1) {
          ApiService.addQueuedPromise(promise, error);
        }
        if (error.response || (error.retries && error.retries > 1)) {
          dispatch(handleException(error, rejectLinkAccountToImyStructure, true));
        }
      });
    return promise();
  };
}
